(function () {
  function init() {
    // If Liquid already rendered stat boxes from metafields, leave the description untouched.
    if (document.querySelector('.product-stats[data-spec-source="metafields"]')) return;
    var desc = document.querySelector('.product__description[data-spec-render]');
    if (!desc || desc.dataset.specRendered === '1') return;
    desc.dataset.specRendered = '1';

    var rawHtml = desc.innerHTML;
    var rawText = desc.textContent.replace(/ /g, ' ');

    function decodeEntities(s) {
      var ta = document.createElement('textarea');
      ta.innerHTML = s;
      return ta.value;
    }

    function clean(s) {
      return decodeEntities(s)
        .replace(/<[^>]+>/g, '')
        .replace(/ /g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/^[\s:\-•·]+|[\s:\-•·]+$/g, '')
        .trim();
    }

    function extract(label) {
      var safe = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var patterns = [
        new RegExp(safe + '\\s*:?\\s*</strong>\\s*([^<\\n]+?)(?:<|$)', 'i'),
        new RegExp('<strong>\\s*-?\\s*' + safe + '\\s*:?\\s*([^<\\n]+?)\\s*</strong>', 'i'),
        new RegExp(safe + '\\s*:\\s*([^<\\n,]+?)(?:<br|$|<\\/|,\\s*<)', 'i'),
      ];
      for (var i = 0; i < patterns.length; i++) {
        var m = rawHtml.match(patterns[i]);
        if (m && m[1]) {
          var v = clean(m[1]);
          if (v && v.length < 200) return v;
        }
      }
      var textRe = new RegExp(safe + '\\s*:\\s*([^\\n]+?)(?:\\n|$)', 'i');
      var tm = rawText.match(textRe);
      if (tm && tm[1]) return clean(tm[1].split(/(?:CBD|CBDX|THC|Aroma|Qualität|Konsistenz|EU-Nutzhanf)/)[0]);
      return null;
    }

    var data = {
      cbd: extract('CBD-Gehalt'),
      cbdx: extract('CBDX-Gehalt'),
      thc: extract('THC-Gehalt'),
      nutzhanf: extract('EU-Nutzhanf'),
      qualitaet: extract('Qualität'),
      aroma: extract('Aroma'),
      konsistenz: extract('Konsistenz'),
    };

    if (!data.cbd && !data.cbdx) return;

    function makeStat(label, value, modifier) {
      var stat = document.createElement('div');
      stat.className = 'product-stat' + (modifier ? ' ' + modifier : '');
      var lbl = document.createElement('span');
      lbl.className = 'product-stat__label';
      lbl.textContent = label;
      var val = document.createElement('span');
      val.className = 'product-stat__value';
      val.textContent = value;
      stat.appendChild(lbl);
      stat.appendChild(val);
      return stat;
    }

    var stats = document.createElement('div');
    stats.className = 'product-stats';
    if (data.cbd) stats.appendChild(makeStat('CBD', data.cbd));
    if (data.cbdx) stats.appendChild(makeStat('CBDX', data.cbdx, 'product-stat--cbdx'));
    if (data.thc) stats.appendChild(makeStat('THC', data.thc, 'product-stat--thc'));

    // Build organic prose paragraph
    var titleEl = document.querySelector('.product__title h1, h1.product__title');
    var rawTitle = titleEl ? titleEl.textContent.trim() : '';

    function shortName(t) {
      // Prefer quoted segment, else last "- segment"
      var quoted = t.match(/[""„"](.+?)[""„"]/);
      if (quoted) return quoted[1].trim();
      var parts = t.split(/\s*[-–—]\s*/);
      return parts[parts.length - 1].replace(/[""„"]/g, '').trim();
    }

    function detectProductKind(title) {
      var t = title.toLowerCase();
      if (t.indexOf('hasch') !== -1) return { noun: 'Das Hasch', plural: false };
      if (t.indexOf('blüten') !== -1 || t.indexOf('bluten') !== -1) return { noun: 'Die Blüten', plural: true };
      return { noun: 'Das Produkt', plural: false };
    }

    function joinList(items) {
      if (items.length <= 1) return items.join('');
      return items.slice(0, -1).join(', ') + ' und ' + items[items.length - 1];
    }

    var numberWords = { 2: 'zwei', 3: 'drei', 4: 'vier', 5: 'fünf', 6: 'sechs', 7: 'sieben', 8: 'acht' };
    function numWord(n) { return numberWords[n] || String(n); }

    var name = shortName(rawTitle);
    var kind = detectProductKind(rawTitle);
    var sorten = data.nutzhanf ? data.nutzhanf.split(/\s*,\s*/).filter(Boolean) : [];

    // Sentence 1: Origin (name + Nutzhanf)
    var s1 = '';
    if (sorten.length >= 3) {
      s1 = 'Unser ' + name + ' vereint ' + numWord(sorten.length) + ' EU-Nutzhanf-Sorten – ' + joinList(sorten) + '.';
    } else if (sorten.length === 2) {
      s1 = 'Unser ' + name + ' wird aus den EU-Nutzhanf-Sorten ' + joinList(sorten) + ' gewonnen.';
    } else if (sorten.length === 1) {
      s1 = 'Unser ' + name + ' wird aus dem EU-Nutzhanf ' + sorten[0] + ' gewonnen.';
    } else if (name) {
      s1 = 'Unser ' + name + '.';
    }

    // Sentence 2: Quality + consistency (cleaner prose without double "und")
    var s2 = '';
    if (data.qualitaet || data.konsistenz) {
      var verb = kind.plural ? 'sind' : 'ist';
      var qualityClause = '';
      if (data.qualitaet) qualityClause = kind.noun + ' ' + verb + ' in ' + data.qualitaet + '-Qualität gezogen';
      var konsistenzClause = '';
      if (data.konsistenz) {
        var konsi = data.konsistenz.split(/\s*,\s*/).filter(Boolean);
        konsistenzClause = joinList(konsi) + ' in der Konsistenz';
      }
      if (qualityClause && konsistenzClause) {
        s2 = qualityClause + ', ' + konsistenzClause + '.';
      } else if (qualityClause) {
        s2 = qualityClause + '.';
      } else if (konsistenzClause) {
        s2 = kind.noun + ' ' + verb + ' ' + konsistenzClause + '.';
      }
    }

    // Sentence 3: Aroma
    var s3 = '';
    if (data.aroma) {
      if (/a\s*bis\s*z/i.test(data.aroma)) {
        s3 = (kind.plural ? 'Sie decken' : 'Es deckt') + ' im Aroma die volle Bandbreite von A bis Z ab.';
      } else {
        var aromas = data.aroma.split(/\s*,\s*/).filter(Boolean);
        if (aromas.length === 1) {
          s3 = 'Im Aroma ' + aromas[0] + '.';
        } else {
          s3 = 'Im Aroma ' + joinList(aromas) + '.';
        }
      }
    }

    var paragraphText = [s1, s2, s3].filter(Boolean).join(' ');

    var specBlock = document.createElement('div');
    specBlock.className = 'product-spec-text';
    if (paragraphText) {
      var p = document.createElement('p');
      p.textContent = paragraphText;
      specBlock.appendChild(p);
    }

    var beforeNode = desc.querySelector('ul, p');
    if (beforeNode) {
      desc.insertBefore(stats, beforeNode);
      desc.insertBefore(specBlock, beforeNode);
    } else {
      desc.prepend(specBlock);
      desc.prepend(stats);
    }

    var firstUl = desc.querySelector('ul');
    if (firstUl) firstUl.classList.add('product-spec-original-hidden');
    var firstP = desc.querySelector('p');
    if (firstP && /(?:CBD-Gehalt|EU-Nutzhanf):/.test(firstP.textContent)) {
      firstP.classList.add('product-spec-original-hidden');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
